export const catalogTypes = {
  UP_CATALOG_GET_CHECKOUT_SESSION: 'UP_CATALOG_GET_CHECKOUT_SESSION',
}